import { useState, useEffect } from 'react';

// Responsive hook — updates on resize unlike window.innerWidth in styles
export const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [breakpoint]);

  return isMobile;
};

export const useIsTablet = () => useIsMobile(1024);
export const useIsSmallMobile = () => useIsMobile(480);

export default useIsMobile;
